"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardType = void 0;
var LeaderboardType;
(function (LeaderboardType) {
    LeaderboardType["USERS"] = "users";
    LeaderboardType["TEAMS"] = "teams";
})(LeaderboardType = exports.LeaderboardType || (exports.LeaderboardType = {}));
